export default {
  'portal.error.automy.title': 'We were unable to complete the automatic switch back to AUTOMY.',
  'portal.error.auth.title': 'We were unable to complete the automatic switch to the portal.',
  'portal.error.description': `Please log back in to continue. This helps us keep your information secure and ensure everything is working properly.`,
};
